import { AlertTriangle } from 'lucide-react';

type StaleDataBannerProps = {
  isStale: boolean;
};

export const StaleDataBanner = ({ isStale }: StaleDataBannerProps) => {
  if (!isStale) return null;

  return (
    <div
      role="alert"
      className="flex items-center gap-3 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800"
    >
      <AlertTriangle className="h-4 w-4 flex-shrink-0 text-amber-600" />
      <span>
        Data may be outdated. The last refresh was more than 2 hours ago. Click
        Refresh to update.
      </span>
    </div>
  );
};
